// extracted by mini-css-extract-plugin
export var md = "_2x-4";
export var semantic = "_2x-5";
export var sm = "_2x-3";
export var text = "_2x-6";
export var toggleInput = "_2x-0";
export var toggleSwitch = "_2x-1";
export var xs = "_2x-2";